import { connect } from 'react-redux';

import {
  initializeBalance,
  updateLatestTask,
} from '../../balance/actions/actions';
import {
  deleteBookingEntry,
  loadBookingEntries,
} from '../../balance/actions/booking-entry-actions';
import { deleteInvoice } from '../../balance/actions/invoice-actions';
import ProjectInvoiceForm from './ProjectInvoiceForm';

export default connect(
  ({ balance }, props) => ({
    invoices: balance.invoices,
    bookingEntries: balance.bookingEntries,
    initialized: balance.context.opportunityId === props.opportunity.id,
    loading: balance.loading,
    latestTask: balance.context.latestTask,
  }),
  {
    onInitialize: initializeBalance,
    onDeleteBookingEntry: deleteBookingEntry,
    onDeleteInvoice: deleteInvoice,
    onUpdateLatestTask: updateLatestTask,
    onReloadBookingEntries: loadBookingEntries,
  },
)(ProjectInvoiceForm);
